module.exports = __webpack_public_path__ + "assets/3bef65ee2af4e6dcf07850726d3e6190.mp3";